import { Outlet, useNavigation } from "react-router-dom";
import { useSelector } from "react-redux";

import MainNavigation from "../components/navigation/MainNavigation";
import Footer from "../components/common/Footer";
import LocationCompletionModal from "../components/common/LocationCompletionModal";

function RootLayout() {
  const loggedInUser = useSelector((state) => state.auth.user);
  // console.log("footer log:", loggedInUser == null ) 
  return (
    <>
      <MainNavigation />
      {loggedInUser  && <LocationCompletionModal/>} 
      <main className="min-vh-100">
        {/* {navigation.state === 'loading' && <p>Loading...</p>} */}
        <Outlet/>
        <Footer/>
      </main> 
    </>
  );
} 

export default RootLayout;
